// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// MobileUtils Module

define('MobileUtils',['require'],function (require) {
    'use strict';

    var // Instance vars
        self,

        isMobilePlatform,
        isMobileAppDeployment,
        isFileUrlDeployment,
        isIOSPlatform,
        isIPadPlatform,
        isAndroidPlatform,
        isAndroidEmulatorPlatform,
        iosVersion,
        androidVersion;

    // Constructor
    function MobileUtils () {
        // Preserve instance reference and enforce singleton
        if (typeof self === 'object') { return self; } else { self = this; }
    };

    // Public Methods

    // Use simple method to determine if running on mobile.  There is no smoking
    // gun approach yet, but here is the current strategy to best guess mobile...
    //
    // 1) Compare userAgent strings against commonly known mobile values
    //    OR
    // 2) Touchable device AND
    //    The screenX,screenY value is 0,0 and the browser is full screen
    //
    MobileUtils.prototype.isMobile = function () {
        if (typeof isMobilePlatform === 'undefined') {
            isMobilePlatform = false;
            if (navigator.userAgent.match(
                /Android|BlackBerry|BB10; Touch|iPhone|iPad|iPod|Opera Mini|IEMobile/i) ||
                ('ontouchstart' in document.documentElement &&
                window.screenX && window.screenX === 0 &&
                window.screenWidth && window.screenAvailableWidth &&
                window.screenWidth === window.screenAvailableWidth)) {
                isMobilePlatform = true;
            }
        }
        return isMobilePlatform;
    };

    // Check for Mobile App
    MobileUtils.prototype.isMobileApp = function () {
        if (typeof isMobileAppDeployment === 'undefined') {
            isMobileAppDeployment = this.isMobile() && this.isFileUrl();
        }
        return isMobileAppDeployment;
    };

    // Check for IOS Platform
    MobileUtils.prototype.isIOS = function () {
        if (typeof isIOSPlatform === 'undefined') {
            isIOSPlatform = false;
            if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
                isIOSPlatform = true;
            }
        }
        return isIOSPlatform;
    };

    // Check for Android Platform
    MobileUtils.prototype.isAndroid = function () {
        if (typeof isAndroidPlatform === 'undefined') {
            isAndroidPlatform = false;
            if (navigator.userAgent.match(/Android/i)) {
                isAndroidPlatform = true;
            }
        }
        return isAndroidPlatform;
    };

    // Check for Android Emulator
    MobileUtils.prototype.isAndroidEmulator = function () {
        if (typeof isAndroidEmulatorPlatform === 'undefined') {
            isAndroidEmulatorPlatform =
                this.isMobile() && window.device && window.device.model &&
                (window.device.model.indexOf('Android SDK built') >= 0 ||
                 window.device.model === 'sdk');
        }
        return isAndroidEmulatorPlatform;
    };

    // Get Android version
    MobileUtils.prototype.getAndroidVersion = function () {
        if (typeof androidVersion === 'undefined') {
            var match = navigator.userAgent.match(/Android\s([0-9\.]*)/);
            androidVersion = match ? match[1] : '';
        }
        return androidVersion;
    };

    // Need to check for iPad
    MobileUtils.prototype.isIPad = function () {
        if (typeof isIPadPlatform === 'undefined') {
            isIPadPlatform = false;
            if (navigator.userAgent.match(/iPad/)) {
                isIPadPlatform = true;
            }
        }
        return isIPadPlatform;
    };

    // Get the IOS version
    MobileUtils.prototype.getIOSVersion = function () {
        if (typeof iosVersion === 'undefined') {
            iosVersion = parseFloat(('' +
                (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i
                .exec(navigator.userAgent) || [0,''])[1])
                .replace('undefined', '3_2').replace('_', '.')
                .replace('_', '')) || false;
        }
        return iosVersion;
    };

    // Check for file URL which is used in mobile app
    MobileUtils.prototype.isFileUrl = function () {
        if (typeof isFileUrlDeployment === 'undefined') {
            isFileUrlDeployment =
                document.location.toString().indexOf('file') == 0;
        }
        return isFileUrlDeployment;
    };

    // Return Constructor
    return MobileUtils.prototype.constructor;
});

